/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttachmentStateDto } from '../models';
// @ts-ignore
import type { EmailBasicDto } from '../models';
// @ts-ignore
import type { EmailFolderDto } from '../models';
// @ts-ignore
import type { EmailFolderStateDto } from '../models';
// @ts-ignore
import type { EmailSearchRequestDto } from '../models';
// @ts-ignore
import type { EmailThreadDto } from '../models';
// @ts-ignore
import type { EmailThreadsDto } from '../models';
// @ts-ignore
import type { EmailsSortByDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * RestEmailReaderApi - axios parameter creator
 */
export const RestEmailReaderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment: async (userId: string, emailId: string, externalAttachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAttachment', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('getAttachment', 'emailId', emailId)
            // verify required parameter 'externalAttachmentId' is not null or undefined
            assertParamExists('getAttachment', 'externalAttachmentId', externalAttachmentId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/attachments/{externalAttachmentId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)))
                .replace('{externalAttachmentId}', encodeURIComponent(String(externalAttachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentState: async (userId: string, emailId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAttachmentState', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('getAttachmentState', 'emailId', emailId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getAttachmentState', 'attachmentId', attachmentId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/attachments/{attachmentId}/state`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all email folders
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFolders: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailFolders', 'userId', userId)
            const localVarPath = `/api/users/{userId}/emails/folders`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all email folders state
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFoldersState: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailFoldersState', 'userId', userId)
            const localVarPath = `/api/users/{userId}/emails/folders/state`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get email by id
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmail: async (userId: string, emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('readEmail', 'emailId', emailId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all emails\' threads for user for folder
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {boolean} [unreadOnly] 
         * @param {EmailsSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {EmailSearchRequestDto} [emailSearchRequestDto] Email search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmails: async (userId: string, userEmailFolderId: string, page: number, pageSize: number, unreadOnly?: boolean, sortBy?: EmailsSortByDto, sortOrder?: SortDirectionDto, emailSearchRequestDto?: EmailSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readEmails', 'userId', userId)
            // verify required parameter 'userEmailFolderId' is not null or undefined
            assertParamExists('readEmails', 'userEmailFolderId', userEmailFolderId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('readEmails', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('readEmails', 'pageSize', pageSize)
            const localVarPath = `/api/emails/{userId}/threads`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userEmailFolderId !== undefined) {
                localVarQueryParameter['userEmailFolderId'] = userEmailFolderId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all emails\' by thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readThread: async (userId: string, emailThreadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readThread', 'userId', userId)
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('readThread', 'emailThreadId', emailThreadId)
            const localVarPath = `/api/emails/{userId}/threads/{emailThreadId}`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailThreadId}', encodeURIComponent(String(emailThreadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmailReaderApi - functional programming interface
 */
export const RestEmailReaderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmailReaderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachment(userId, emailId, externalAttachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.getAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachmentState(userId: string, emailId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachmentState(userId, emailId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.getAttachmentState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all email folders
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailFolders(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailFolderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailFolders(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.getEmailFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all email folders state
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailFoldersState(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailFolderStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailFoldersState(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.getEmailFoldersState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get email by id
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailBasicDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readEmail(userId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.readEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all emails\' threads for user for folder
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {boolean} [unreadOnly] 
         * @param {EmailsSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {EmailSearchRequestDto} [emailSearchRequestDto] Email search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readEmails(userId: string, userEmailFolderId: string, page: number, pageSize: number, unreadOnly?: boolean, sortBy?: EmailsSortByDto, sortOrder?: SortDirectionDto, emailSearchRequestDto?: EmailSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailThreadsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readEmails(userId, userEmailFolderId, page, pageSize, unreadOnly, sortBy, sortOrder, emailSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.readEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all emails\' by thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailThreadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readThread(userId, emailThreadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmailReaderApi.readThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmailReaderApi - factory interface
 */
export const RestEmailReaderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmailReaderApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} externalAttachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAttachment(userId, emailId, externalAttachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentState(userId: string, emailId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentStateDto> {
            return localVarFp.getAttachmentState(userId, emailId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all email folders
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFolders(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderDto>> {
            return localVarFp.getEmailFolders(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all email folders state
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailFoldersState(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderStateDto>> {
            return localVarFp.getEmailFoldersState(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get email by id
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailBasicDto> {
            return localVarFp.readEmail(userId, emailId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all emails\' threads for user for folder
         * @param {string} userId 
         * @param {string} userEmailFolderId 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {boolean} [unreadOnly] 
         * @param {EmailsSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {EmailSearchRequestDto} [emailSearchRequestDto] Email search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmails(userId: string, userEmailFolderId: string, page: number, pageSize: number, unreadOnly?: boolean, sortBy?: EmailsSortByDto, sortOrder?: SortDirectionDto, emailSearchRequestDto?: EmailSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmailThreadsDto> {
            return localVarFp.readEmails(userId, userEmailFolderId, page, pageSize, unreadOnly, sortBy, sortOrder, emailSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all emails\' by thread
         * @param {string} userId 
         * @param {string} emailThreadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailThreadDto> {
            return localVarFp.readThread(userId, emailThreadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmailReaderApi - interface
 */
export interface RestEmailReaderApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} externalAttachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentState(userId: string, emailId: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttachmentStateDto>;

    /**
     * 
     * @summary Get all email folders
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailFolders(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderDto>>;

    /**
     * 
     * @summary Get all email folders state
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailFoldersState(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailFolderStateDto>>;

    /**
     * 
     * @summary Get email by id
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailBasicDto>;

    /**
     * 
     * @summary Get all emails\' threads for user for folder
     * @param {string} userId 
     * @param {string} userEmailFolderId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {boolean} [unreadOnly] 
     * @param {EmailsSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {EmailSearchRequestDto} [emailSearchRequestDto] Email search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readEmails(userId: string, userEmailFolderId: string, page: number, pageSize: number, unreadOnly?: boolean, sortBy?: EmailsSortByDto, sortOrder?: SortDirectionDto, emailSearchRequestDto?: EmailSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmailThreadsDto>;

    /**
     * 
     * @summary Get all emails\' by thread
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailThreadDto>;

}

/**
 * RestEmailReaderApi - object-oriented interface
 */
export class RestEmailReaderApi extends BaseAPI implements RestEmailReaderApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} externalAttachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachment(userId: string, emailId: string, externalAttachmentId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).getAttachment(userId, emailId, externalAttachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachmentState(userId: string, emailId: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).getAttachmentState(userId, emailId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all email folders
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailFolders(userId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).getEmailFolders(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all email folders state
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailFoldersState(userId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).getEmailFoldersState(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get email by id
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).readEmail(userId, emailId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all emails\' threads for user for folder
     * @param {string} userId 
     * @param {string} userEmailFolderId 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {boolean} [unreadOnly] 
     * @param {EmailsSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {EmailSearchRequestDto} [emailSearchRequestDto] Email search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readEmails(userId: string, userEmailFolderId: string, page: number, pageSize: number, unreadOnly?: boolean, sortBy?: EmailsSortByDto, sortOrder?: SortDirectionDto, emailSearchRequestDto?: EmailSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).readEmails(userId, userEmailFolderId, page, pageSize, unreadOnly, sortBy, sortOrder, emailSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all emails\' by thread
     * @param {string} userId 
     * @param {string} emailThreadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readThread(userId: string, emailThreadId: string, options?: RawAxiosRequestConfig) {
        return RestEmailReaderApiFp(this.configuration).readThread(userId, emailThreadId, options).then((request) => request(this.axios, this.basePath));
    }
}

